<template>
    <v-row id="seriesAwardsSection">
        <v-col cols="12" md="4" sm="6" class="mx-auto">
            <v-select ref="groupClassFilter" class="my-2 classFilter" v-model="selectedGroupClass"
                :items="groupClassNamesCom" item-text="text" item-value="value"
                :label="$t('page.series.filter_group_class')" multiple outlined dense
                :menu-props="{ top: true, offsetY: true }"
                :no-data-text="$t('common.no_data')"
            >
                <template v-slot:selection="{ item, index }">
                    <v-chip v-if="selectedGroupClass.length == 1 && index === 0">
                        <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="selectedGroupClass.length > 1 && index === 0" class="grey--text caption">
                        (+{{ selectedGroupClass.length - 1 }} others)
                    </span>
                </template>
            </v-select>
        </v-col>
        <v-col cols="12">
            <div>
                <v-data-table ref="tableAward" key="tableAward" :headers="showColumns" dense
                    :items="filteredItemsFormat" 
                    :footer-props="{
                        itemsPerPageOptions: [10, 20, 30, 40, 50, -1],
                        itemsPerPageText: $t('dataTable.rowsPerPageText'),
                        itemsPerPageAllText: $t('dataTable.rowsPerPageAllText')
                    }" 
                    :items-per-page="10" 
                    class="elevation-1" 
                    mobile-breakpoint="0" 
                    style="min-width: 350px;"
                    hide-default-header 
                    :draggable="false" 
                    :no-data-text="$t('dataTable.noDataText')"
                    :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                    }"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <thead class="headTable">
                            <tr>
                                <th v-for="(h, i) in headers" :key="`item-${i}`" 
                                    :style="{
                                        cursor: 'pointer',
                                        textAlign: 'center'
                                    }" 
                                    :class="`${h.class ? h.class : ''}`" 
                                    @click="sortableCustom(h.value)"
                                >
                                    <span>
                                        <span v-html="$te(h.text) ? $t(h.text) : h.text"></span>
                                        <v-icon small class="float-right mx-3">fas fa-sort</v-icon>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                    </template>
                    <template v-slot:item="{ item }">
                        <tr :draggable="false">
                            <td :draggable="false">
                                <div class="fullName">{{ item.fullName }}</div>
                            </td>
                            <td @mousedown="mouseDown" :draggable="false">
                                <span>{{ item.groupClassName.toUpperCase() }}</span></td>
                            <td @mousedown="mouseDown" :draggable="false">{{ item.position }}</td>
                            <td @mousedown="mouseDown" :draggable="false">
                                <span
                                    :class="(item.brandName || '').replace(' ', '').toLowerCase()">{{ item.brandName }}</span>
                            </td>
                            <td>
                                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                                <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-col>
        <v-dialog v-model="dialog" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline type-title">
                        {{ $t('page.series.edit-award', { fullName: item ? item.fullName : '' }) }}
                    </span>
                    <v-icon class="ml-auto" @click="close">fa-times</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formEdit" class="formEdit">
                        <br />
                        <v-row>
                            <v-col cols="12">
                                <v-select 
                                    outlined dense 
                                    :label="$t('common.form.group_class')"
                                    :items="groupClassNamesCom" 
                                    v-model="groupClass" 
                                    disabled
                                    :no-data-text="$t('common.no_data')"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field outlined dense
                                    :label="$t('common.form.position')"
                                    v-model="positionAward"
                                    :rules="[value => $inputRules({value}, 'integer') || $t('page.series.position-invalid')]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-select 
                                    outlined dense 
                                    :label="$t('common.form.brand')" 
                                    :items="brandItems"
                                    v-model="brand" 
                                    item-value="id" 
                                    item-text="brandName"
                                    return-object
                                    :rules="brandRules" 
                                    :no-data-text="$t('common.no_data')"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" dark small @click="close">{{ $t('common.form.cancel') }}</v-btn>
                    <v-btn color="darken-1" dark small @click="save">{{ $t('common.form.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')"
            @cancel="dialogNotification = false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')"
            :reject="$t('common.form.cancel')" />
        <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert"
            type='error' />
    </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
    mixins: [apiCalls],
    components: { SGSNotificationConfirm, SGSNotificationAlert },
    mounted() { },
    created()
    {
        this.getList();
        this.getFilters();
    },
    data()
    {
        return {
            itemPerPage: 10,
            sortBy: 'groupClassName',
            sortDesc: false,
            filteredItemsAwards: [],
            groupClassNames: [],
            selectedGroupClass: null,
            item: null,
            groupClassItems: [],
            groupClass: null,
            positionAward: null,
            brandItems: [],
            brand: null,
            dialog: false,
            dialogNotification: false,
            dialogAlert: false,
            alertMessage: '',
            reopenEdition: false
        };
    },
    computed: {
        showColumns()
        {
            return [
                {
                    "text": "page.series.table.awards.name",
                    "value": "fullName"
                },
                {
                    "text": "page.series.table.awards.groupClassName",
                    "value": "groupClassName"
                },
                {
                    "text": "page.series.table.awards.awardPositions",
                    "value": "position"
                },
                {
                    "text": "page.series.table.awards.brand",
                    "value": "brandName"
                },
                {
                    "text": "common.actions",
                    "value": "actions"
                }
            ];
        },
        filteredItemsFormat()
        {
            let results = this.filteredItemsAwards;

            let mapResults = results.map((el) =>
            {
                return {
                    ...el,
                    fullName: ((el.firstName || "") + " " + (el.lastName || "")).trim(),
                    groupClassName: el.className || el.groupName || this.$t('page.series.overall'),
                    brand: el.brandName
                };
            });

            return mapResults.filter((el) =>
            {
                if (!this.selectedGroupClass || this.selectedGroupClass.length == 0) return true;
                let find = this.selectedGroupClass.find((el1) =>
                {
                    return (el1 || "").trim().toLowerCase() == (el.groupClassName || "").trim().toLowerCase();
                });
                return find;
            }).filter((el) =>
            {
                return (el[this.sortBy] || (typeof el[this.sortBy] != 'string' && el[this.sortBy] == 0));
            }).sort((a, b) =>
            {
                if (this.sortBy == 'groupClassName')
                {
                    let cond = 0;
                    if (this.sortDesc)
                    {
                        cond = b.sortOrder - a.sortOrder;
                    } else
                    {
                        cond = a.sortOrder - b.sortOrder;
                    }
                    if (cond == 0)
                    {
                        let __a = a.groupClassName.toLowerCase();
                        let __b = b.groupClassName.toLowerCase();
                        if (this.sortDesc)
                        {
                            cond = __a < __b ? 1 : (__a == __b ? 0 : -1);
                        } else
                        {
                            cond = __a > __b ? 1 : (__a == __b ? 0 : -1);
                        }
                        if (cond == 0)
                        {
                            if (this.sortDesc)
                            {
                                cond = b.position - a.position;
                            } else
                            {
                                cond = a.position - b.position;
                            }
                        }
                    }
                    return cond;
                } else if (typeof a[this.sortBy] == 'string' && typeof b[this.sortBy] == 'string')
                {
                    let _a = a[this.sortBy].toLowerCase();
                    let _b = b[this.sortBy].toLowerCase();
                    let cond = 0;
                    if (this.sortDesc)
                    {
                        cond = _a < _b ? 1 : (_a == _b ? 0 : -1);
                    } else
                    {
                        cond = _a > _b ? 1 : (_a == _b ? 0 : -1);
                    }
                    return cond;
                }
                if (this.sortDesc)
                {
                    return b[this.sortBy] - a[this.sortBy];
                }
                return a[this.sortBy] - b[this.sortBy];
            }).concat(mapResults.filter((el) =>
            {
                return !(el[this.sortBy] || (typeof el[this.sortBy] != 'string' && el[this.sortBy] == 0));
            }));
        },
        ...mapState({
            seriesSelected: state => state.series.seriesSelected
        }),
        groupClassNamesCom()
        {
            let data = []; let groups = []; let classes = [];

            this.groupClassNames.forEach((item) =>
            {
                if (item.fkSeriesGroupId || item.isOverall)
                {
                    groups.push(item);
                } else if (item.fkSeriesClassId)
                {
                    classes.push(item);
                }
            });

            data.push({ header: this.$t('page.series.groups') });
            data = data.concat(groups);
            data.push({ header: this.$t('page.series.classes') });
            data = data.concat(classes);
            return data.map((el) =>
            {
                if (el.header) return el;
                return {
                    value: el.text ? el.text : this.$t('page.series.' + el.index),
                    text: el.text ? el.text : this.$t('page.series.' + el.index)
                }
            });
        },
        groupClassRules()
        {
            return [];
        },
        brandRules()
        {
            return [
                (v) => !!v || this.$t('page.series.brand-required')
            ];
        }
    },
    methods: {
        async getFilters()
        {
            let responseFiltersAwards = await this.getApi(`/api/v1/promoter/series/awards/filters/${this.seriesSelected.id}`);

            if (responseFiltersAwards && responseFiltersAwards.success)
            {
                this.groupClassNames = responseFiltersAwards.message.data.classGroupName;
                this.brandItems = responseFiltersAwards.message.data.brands;
            }
        },
        async getList()
        {
            let responseAwards = await this.getApi(`/api/v1/promoter/series/awards/results/${this.seriesSelected.id}`);

            if (responseAwards && responseAwards.success)
            {
                this.filteredItemsAwards = responseAwards.message.data;
            }
        },
        selectedDefault(bandChangeRace = false)
        {
            this.selectedGroupClass = [];
            if (!bandChangeRace || !(bandChangeRace && this.sortBy == 'groupClassName' && this.sortDesc === false))
            {
                this.sortableCustom('groupClassName', false);
            }
        },
        filteredItemsForGroupClass(item)
        {
            return this.filteredItemsFormat.map((el) =>
            {
                return {
                    ...el,
                    fullName: ((el.firstName || "") + " " + (el.lastName || "")).trim(),
                    groupClassName: el.className || el.groupName || this.$t('races.overall'),
                    brand: el.brandName
                };
            }).filter((el) =>
            {
                return el.seriesAwardsId == item;
            }).sort((a, b) =>
            {
                if (typeof a[this.sortByItems[item]] == 'string' && typeof b[this.sortByItems[item]] == 'string')
                {
                    let _a = a[this.sortByItems[item]].toLowerCase();
                    let _b = b[this.sortByItems[item]].toLowerCase();
                    if (this.sortDescItems[item])
                    {
                        return _a < _b ? 1 : (_a == _b ? 0 : -1);
                    }
                    return _a > _b ? 1 : (_a == _b ? 0 : -1);
                }
                if (this.sortDescItems[item])
                {
                    return b[this.sortByItems[item]] - a[this.sortByItems[item]];
                }
                return a[this.sortByItems[item]] - b[this.sortByItems[item]];
            });
        },
        titleForGroupClass(item)
        {
            const find = this.groupClassNamesCom.find((el) => el.value == item);
            if (find) return find.text;
            return "";
        },
        loadClassItems()
        {
            let results = [];
            this.selectedGroupClass.forEach((item) =>
            {
                results[item] = this.filteredItemsFormat.map((el) =>
                {
                    return {
                        ...el,
                        fullName: ((el.firstName || "") + " " + (el.lastName || "")).trim(),
                        groupClassName: el.className || el.groupName || this.$t('races.overall'),
                        brand: el.brandName
                    };
                }).filter((el) =>
                {
                    return el.seriesAwardsId == item;
                }).sort((a, b) =>
                {
                    if (typeof a[this.sortByItems[item]] == 'string' && typeof b[this.sortByItems[item]] == 'string')
                    {
                        let _a = a[this.sortByItems[item]].toLowerCase();
                        let _b = b[this.sortByItems[item]].toLowerCase();
                        if (this.sortDescItems[item])
                        {
                            return _a < _b ? 1 : (_a == _b ? 0 : -1);
                        }
                        return _a > _b ? 1 : (_a == _b ? 0 : -1);
                    }
                    if (this.sortDescItems[item])
                    {
                        return b[this.sortByItems[item]] - a[this.sortByItems[item]];
                    }
                    return a[this.sortByItems[item]] - b[this.sortByItems[item]];
                });
            });
            this.filteredItemsForGroupClassArray = results;
        },
        mouseDown($event, ref = 'tableAward')
        {
            const vm = this;
            //const element = $event.target;
            let screenX1 = $event.screenX;
            let refs = vm.$refs[ref];
            const mouseMove = (e) =>
            {
                if (refs)
                {
                    let element = refs[0];
                    if (element)
                    {
                        element = element.$el.getElementsByClassName('v-data-table__wrapper');
                        if (element.length > 0)
                        {
                            element = element[0];
                            let screenX2 = e.screenX;
                            if (screenX2 > screenX1)
                            {
                                element.scrollLeft = element.scrollLeft + 10;
                            } else
                            {
                                element.scrollLeft = element.scrollLeft - 10;
                            }
                        }
                    }
                }
            }
            const dragEvent = (event) =>
            {
                event.preventDefault();
                document.removeEventListener('mousemove', mouseMove);
            }
            const selectStartEvent = (e) =>
            {
                e.preventDefault();
            };
            const mouseUp = () =>
            {
                document.removeEventListener('mousemove', mouseMove);
                document.removeEventListener('mouseup', mouseUp);
                document.removeEventListener("drag", dragEvent);
                document.removeEventListener('selectstart', selectStartEvent);
            }
            if (refs)
            {
                let element = refs[0];
                if (element)
                {
                    element = element.$el.getElementsByClassName('v-data-table__wrapper');
                    if (element.length > 0)
                    {
                        element = element[0];
                        let table = element.getElementsByTagName('table');
                        table = table.length > 0 ? table[0] : null;
                        if (table && table.clientWidth > element.clientWidth)
                        {
                            document.addEventListener('mousemove', mouseMove);
                            document.addEventListener('mouseup', mouseUp);
                            document.addEventListener("drag", dragEvent);
                            document.addEventListener('selectstart', selectStartEvent);
                        }
                    }
                }
            }
        },
        itemsPerPageChange(value)
        {
            this.itemsPerPage = parseInt(value, 10);
        },
        editItem(item)
        {
            if (item)
            {
                this.item = item;
                this.groupClass = this.item.groupClassName;
                this.positionAward = this.item.position;
                const find = this.brandItems.find((el) => el.brandName == this.item.brand);
                const find1 = this.brandItems.find((el) => el.brandName.trim().toLowerCase() == (this.item.brand ?this.item.brand.trim().toLowerCase() : this.item.brand));
                this.brand = find ? find : find1;
                this.dialog = true;
            }
        },
        confirmDelete(item)
        {
            this.item = item;
            this.dialogNotification = true;
        },
        async save()
        {
            if (this.$refs.formEdit.validate())
            {
                let data = {
                    id: this.item.id,
                    position: this.positionAward,
                    brandName: this.brand ? this.brand.brandName : null,
                    seriesId: this.seriesSelected.id
                };
                let response = await this.putApi(`/api/v1/promoter/series/awards/results`, data);
                if (response && response.success)
                {
                    this.getList();
                    this.dialog = false;
                } else
                {
                    if (!response || (response && !response.success))
                    {
                        this.alertMessage = this.$t('page.series.error_general');
                        if (response && Array.isArray(response.error) && response.error.length > 0)
                        {
                            this.alertMessage = this.$t('common.request.' + response.error[0]);
                        } else if (response && typeof response.error == 'string')
                        {
                            this.alertMessage = this.$t('common.request.' + response.error)
                        } else if (response && Array.isArray(response.message) && response.message.length > 0)
                        {
                            this.alertMessage = this.$t('common.request.' + response.message[0]);
                        } else if (response && typeof response.message == 'string')
                        {
                            this.alertMessage = this.$t('common.request.' + response.message)
                        }
                        this.dialog = false;
                        this.dialogAlert = true;
                        this.reopenEdition = true;
                        return;
                    }
                }
            }
        },
        close()
        {
            this.dialog = false;
        },
        async deleteItem()
        {
            if (this.item)
            {
                let response = await this.deleteApi(`/api/v1/promoter/series/awards/results/${this.item.id}`);

                if (response && response.success)
                {
                    this.getList();
                    this.dialogNotification = false;
                } else
                {
                    if (!response || (response && !response.success))
                    {
                        this.alertMessage = this.$t('page.series.error_general');
                        if (response && Array.isArray(response.error) && response.error.length > 0)
                        {
                            this.alertMessage = this.$t('common.request.' + response.error[0]);
                        } else if (response && typeof response.error == 'string')
                        {
                            this.alertMessage = this.$t('common.request.' + response.error)
                        } else if (response && Array.isArray(response.message) && response.message.length > 0)
                        {
                            this.alertMessage = this.$t('common.request.' + response.message[0]);
                        } else if (response && typeof response.message == 'string')
                        {
                            this.alertMessage = this.$t('common.request.' + response.message)
                        }
                        this.dialogAlert = true;
                        this.dialogNotification = true;
                        return;
                    }
                }
            }
        },
        closeAlert()
        {
            this.dialogAlert = false;
            if (this.reopenEdition)
            {
                this.dialog = true;
            }
        }
    },
    watch: {
        seriesSelected(val)
        {
            if (val)
            {
                this.getList();
                this.getFilters();
            }
        }
    },
};
</script>

<style lang="scss">
//brand colors
$yamaha: #000099;
$ktm: #ff6600;
$honda: #e00031;
$suzuki: #ebd623;
$kawasaki: #33cc00;
$gasgas: #e63429;
$sherco: #0606a8;
$beta: #e60000;
$husqvarna: #002550;
$husaberg: #024fa7;
$tm: #00a2d8;

#seriesAwardsSection {
    .theme--dark.v-application {
        color: black;
    }

    body {
        background-color: #f5f5f5;
    }

    :root h1 {
        --color: red;
        display: flex;
        color: var(--color);
    }

    .dsq {
        font-weight: bold;
        color: red;
    }

    .milliseconds,
    .section-posittion {
        font-size: 10px;
    }

    .fared::before,
    .fared {
        color: #f00;
    }

    .text-blue {
        color: #002550;
    }

    .text-small {
        font-size: 11px;
        font-weight: bold;
    }

    .incomplete {
        color: #002550;
        font-size: 0.7em;
    }

    .unscored {
        color: #002550;
        font-size: 0.7em;
    }

    .fill {
        width: 100%;
        height: 100%;
    }

    header,
    #header2 {
        height: 110px;
        -webkit-box-shadow: 0px 0px 3px 0px #999;
        box-shadow: 0px 0px 3px 0px #999;
        margin-bottom: 1px;
    }

    #backButton {
        position: absolute;
        top: 10px;
        left: 18px;
        color: #ccc;
        cursor: pointer;
        text-decoration: none;
        z-index: 1000;
    }

    #raceImage {
        position: absolute;
        top: 40px;
        left: 18px;
        height: 113px;
        z-index: 11;
        width: 150px;
        padding: 2px;
        border: 1px solid #aaa;
        border-radius: 3px;
        background-color: #fff;
    }

    #raceImage img {
        max-width: 100%;
        max-height: 100%;
    }

    #raceDetails {
        position: absolute;
        top: 0px;
        left: 200px;
        padding: 5px;
        padding-left: 5px;
        padding-left: 10px;
        color: #fff;
    }

    #raceDetails #name {
        font-size: 24px;
        color: #fff;
        margin-right: 20px;
        max-width: 475px;
        overflow: hidden;
    }

    #raceDetails #event {
        color: #fff;
        margin-top: 7px;
    }

    #raceDetails #promoter {
        color: #fff;
        margin-top: 7px;
    }

    #topAd {
        position: absolute;
        top: 3px;
        right: 310px;
        height: 90px;
        width: 600px;
        max-width: 600px;
        max-height: 90px;
    }

    #optionWrapper {
        top: 8px;
        right: 15px;
        position: absolute;
    }

    .option {
        cursor: pointer;
        font-size: 11px;
        color: #fff;
        background-repeat: no-repeat;
        padding-left: 21px;
        margin-bottom: 6px;
        padding-top: 4px;
        height: 18px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    #filterPanel {
        position: relative;
        z-index: 10;
        padding: 2px 0 20px 200px;
        width: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 70px;
    }

    .btn {
        color: white !important;
    }

    .headTable tr:first-child {
        background: #ccc !important;
    }

    .headTable tr th:hover,
    .headTable tr th:hover .v-icon.fa-sort {
        color: rgba(0, 0, 0, .8) !important;
    }

    .contentRespTableFilter {
        width: 100%;
        overflow-x: auto;
    }

    @media (min-width: 600px) {

        .contentRespTableFilter .v-data-table-header,
        .contentRespTableFilter .headTableMobile {
            display: none;
        }
    }

    @media (max-width: 599px) {

        .contentRespTableFilter .v-data-table-header-mobile,
        .contentRespTableFilter .v-data-table-header {
            display: none;
        }

        .confirmedOpenRsp.v-card__actions {
            display: block;
        }

        .btn_bg,
        .btn_xs_rsp {
            max-width: 100%;
            min-width: auto !important;
            height: auto !important;
        }

        .btn_bg span,
        .btn_xs_rsp span {
            white-space: normal;
            max-width: 100%;
        }

        .lbl_search .v-text-field__details,
        .lbl_search .v-text-field__details .v-messages {
            min-height: 0px;
            margin-bottom: 0px !important;
        }

        .btn_bg {
            min-height: 50px;
        }

        .btn_xs_rsp {
            min-height: 36px;
        }
    }

    .classFilter .v-text-field__details {
        display: none;
        z-index: 200 !important;
    }

    .classFilter .v-input__slot {
        margin-bottom: 0px !important;
    }

    .v-chip.v-size--default {
        font-size: 12px !important;
        height: 26px !important;
    }

    table>tbody>tr>td:nth-child(1),
    table>thead>tr>th:nth-child(1),
    table>thead>tr>td:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        z-index: 200;
    }

    table>thead>tr:nth-child(1),
    table>thead>tr:nth-child(1)>th {
        max-height: 100px !important;
    }

    table>thead>tr>th {
        background: #ccc !important;
    }

    table>tbody>tr:nth-child(2n + 1)>td:nth-child(1),
    table>tbody>tr:hover:nth-child(2n + 1)>td {
        background: white;
    }

    table>tbody>tr:nth-child(2n),
    table>tbody>tr:nth-child(2n)>td:nth-child(1) {
        background: #eeeeee;
    }

    table>thead>tr>th:nth-child(1) {
        z-index: 200 !important;
    }

    table>tbody>tr>td,
    table>thead>tr>th {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .yamaha {
        background-color: $yamaha;
        color: #fff;
    }

    .ktm {
        background-color: $ktm;
        color: #fff;
    }

    .honda {
        background-color: $honda;
        color: #fff;
    }

    .suzuki {
        background-color: $suzuki;
        color: #fff;
    }

    .kawasaki {
        background-color: $kawasaki;
        color: #fff;
    }

    .gasgas {
        background-color: $gasgas;
        color: #fff;
    }

    .sherco {
        background-color: $sherco;
        color: #fff;
    }

    .beta {
        background-color: $beta;
        color: #fff;
    }

    .husqvarna {
        background-color: $husqvarna;
        color: #fff;
    }

    .husaberg,
    .husaburg {
        background-color: $husaberg;
        color: #fff;
    }

    .tm {
        background-color: $tm;
        color: #fff;
    }

    .fullWidthColumn span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .fullWidthColumn,
    .fullWidthColumn span {
        width: auto !important;
    }

    .fullWidthColumn span {
        white-space: pre;
        display: flex;
    }

    .sectionPositionText {
        font-size: 0.8em;
    }

    .sectionPositionTextStrike {
        text-decoration: line-through;
    }

    .v-text-field.v-text-field--enclosed .v-text-field__details {
        display: none;
    }

    .v-tabs-slider {
        margin-top: -1px;
    }

    .v-icon.v-icon {
        cursor: pointer;
    }

    .v-slide-group__next {
        justify-content: right;
    }

    .v-slide-group__prev {
        justify-content: left;
        display: contents !important;
        visibility: visible !important;
    }

    .initTabs {
        left: 34% !important;
        width: 15% !important;
    }

    .option-loading {
        cursor: wait !important;
    }

    .option-disabled {
        cursor: auto !important;
        color: rgba(255, 255, 255, 0.6) !important;
    }

    .dialog_score {
        width: 60%;
        max-width: 700px;
    }

    .fullName {
        text-transform: capitalize;
        font-size: 0.75rem;
    }

    @media (max-width: 1460px) {
        #ad_600x90 {
            display: none;
        }
    }

    .remove-round {
        border-radius: 0px !important;
    }

    .remove-round .v-card__title.headline {
        padding-bottom: 0px;
    }

    .small-letter {
        font-size: 0.65rem;
    }

    .points-bold {
        font-weight: bold;
    }

    .table_profile p {
        margin-bottom: 0;
        color: #828dd3;
    }

    .table_profile p span {
        font-size: 11px;
        color: grey;
    }

    .tableSeries thead .v-data-table__progress th {
        z-index: 202 !important;
    }

    @-moz-document url-prefix() {
        .v-list-item {
            padding: 0 8px;
            min-width: 50px;
        }
    }

    .widthResp {
        width: 100%;
    }

    .widthResp {

        #event,
        div:nth-child(3) {
            font-size: 14px;
        }
    }

    .d-contents {
        display: contents;
    }
}

.listSeries {
    z-index: 210 !important;
    max-height: 211px !important;
}

.type-title {
    text-transform: capitalize;
}
</style>

<style scoped>
.v-dialog__content {
    z-index: 208 !important;
}
</style>